import { useEffect, useState } from 'react';
import Dialpad from './Dialpad';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import useScreenSize from 'flow/hooks/useScreenSize';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { updateLayoutColumns } from 'flow/actions/app-actions';
import { showCallDialog } from 'flow/actions/call-dialog-actions';
import { DialpadTransition } from './communication-canvas/CSSTransition';
import { clearSelectedThreadMessage } from 'flow/actions/chat-actions';

type Props = {
    showCanvas: boolean;
    showVideoCanvas: boolean;
};

const DialpadWrapper = ({ showCanvas, showVideoCanvas }: Props) => {
    const { showDialpad } = useAppContext();
    const dispatch = useAppDispatch();
    const { width } = useScreenSize();
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    const showThreadMessage = useAppSelector(
        (state) =>
            !!state.chats?.getIn([
                'threadMessage',
                'currentThread',
                'chatMessageKey',
            ]),
    );

    useEffect(() => {
        dispatch(
            updateLayoutColumns(
                (showDialpad || showVideoCanvas || showThreadMessage) &&
                    !showCanvas,
            ),
        );
        setIsSmallScreen(width < 720);

        return () => {
            dispatch(
                updateLayoutColumns(
                    showDialpad ||
                        showThreadMessage ||
                        (showVideoCanvas && !showCanvas),
                ),
            );
        };
    }, [showDialpad, showCanvas, width, showThreadMessage, showVideoCanvas]);

    const dialpadVisible = showDialpad && !showCanvas && !showVideoCanvas;

    useEffect(() => {
        dialpadVisible && dispatch(clearSelectedThreadMessage());
    }, [dialpadVisible]);

    return (
        <DialpadTransition
            transitionIn={showDialpad && !showCanvas && !showVideoCanvas}
            timeout={{
                enter: 3000,
                exit: 300,
            }}
            unmountOnExit={true}
        >
            <Dialpad
                className={twMerge(
                    'animate-slideInDialpad min-w-[360px] overflow-hidden border-s',
                    isSmallScreen ? 'absolute z-50 h-full w-full' : '',
                )}
                isMenu={true}
                onEnter={(number) => {
                    dispatch(showCallDialog(number));
                }}
            />
        </DialpadTransition>
    );
};

export default DialpadWrapper;
